import styled from 'styled-components'

export const Container = styled.div`
  display: none;
  position: absolute;
  width: 0px;
  height: 0px;
  background: transparent;
`
